const relativeFormatter = new Intl.RelativeTimeFormat('en', { numeric: 'auto' })
const compactFormatter = new Intl.NumberFormat('en', { notation: 'compact', maximumFractionDigits: 1 })

export function relativeTime(value?: string) {
  if (!value) return 'Never'
  const seconds = Math.round((new Date(value).getTime() - Date.now()) / 1000)
  const absolute = Math.abs(seconds)
  if (absolute < 60) return relativeFormatter.format(seconds, 'second')
  if (absolute < 3600) return relativeFormatter.format(Math.round(seconds / 60), 'minute')
  if (absolute < 86400) return relativeFormatter.format(Math.round(seconds / 3600), 'hour')
  return relativeFormatter.format(Math.round(seconds / 86400), 'day')
}

export const compactNumber = (value: number) => compactFormatter.format(value)

export function hostname(value: string) {
  try { return new URL(value).hostname.replace(/^www\./, '') } catch { return value }
}

